import { EXPERIMENTS, EXPERIMENTS_DECISIONS } from 'Services/optimizely/optimizely.consts';
import { useOptimizelyDecisionWithCustomUserId } from 'Services/optimizely/useOptimizelyDecisionWithCustomUserId';
import useUser from 'Utilities/hooks/useUser';

interface UseOptimizelyEarlyDocumentsExperimentDecisionBase {
	hasEarlyDocuments: boolean;
	id: number;
	isPaidListing: boolean;
}

export const useOptimizelyEarlyDocumentsExperimentDecision = ({
	hasEarlyDocuments,
	id,
	isPaidListing,
}: UseOptimizelyEarlyDocumentsExperimentDecisionBase) => {
	const { dealerId, id: dealerContactId } = useUser();
	const { decision, isEnabled } = useOptimizelyDecisionWithCustomUserId({
		attributes: {
			dealership_and_contact_id_concat: `${dealerId}_${dealerContactId}`,
			dealership_id: `${dealerId}`,
			hasEarlyDocs: Boolean(hasEarlyDocuments),
			isPaidListing: Boolean(isPaidListing),
		},
		experimentId: EXPERIMENTS.EARLY_DOCS_EXPERIMENT,
		userId: id,
	});

	return (
		isEnabled &&
		(decision === EXPERIMENTS_DECISIONS.EARLY_DOCS_EXPERIMENT.SHOW_EARLY_DOCS ||
			decision === EXPERIMENTS_DECISIONS.EARLY_DOCS_EXPERIMENT.ON)
	);
};
